"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _moment = _interopRequireDefault(require("moment"));
var _vuex = require("vuex");
var _application = require("@/services/application.service");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _default2 = exports.default = {
  name: 'ModalNewApplication',
  props: {
    application: {
      type: Object,
      default: null
    },
    onSuccess: {
      type: Function,
      default: function _default() {}
    },
    createApplication: {
      type: Function,
      default: function _default() {}
    },
    updateApplication: {
      type: Function,
      default: function _default() {}
    }
  },
  data: function data() {
    var _this$application, _this$application2, _this$application3, _this$application4;
    return {
      form: {
        prescricaoId: ((_this$application = this.application) === null || _this$application === void 0 ? void 0 : _this$application.prescricaoId) || '',
        descricao: ((_this$application2 = this.application) === null || _this$application2 === void 0 ? void 0 : _this$application2.descricao) || '',
        dataAplicacao: (_this$application3 = this.application) !== null && _this$application3 !== void 0 && _this$application3.dataAplicacao ? new Date(this.application.dataAplicacao) : new Date(),
        setores: [{
          setorId: ''
        }],
        equipamentoId: ((_this$application4 = this.application) === null || _this$application4 === void 0 ? void 0 : _this$application4.equipamentoId) || ''
      },
      prescricoesDisponiveis: [],
      setoresDisponiveis: [],
      equipamentosDisponiveis: [],
      selectedPrescription: null
    };
  },
  computed: _objectSpread(_objectSpread({}, (0, _vuex.mapGetters)({
    farm: 'GET_FARM'
  })), {}, {
    isEdit: function isEdit() {
      return !!this.application;
    },
    title: function title() {
      return this.isEdit ? 'Editar aplicação' : 'Nova aplicação';
    }
  }),
  mounted: function () {
    var _mounted = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.n = 1;
            return this.loadDropdowns();
          case 1:
            return _context.a(2);
        }
      }, _callee, this);
    }));
    function mounted() {
      return _mounted.apply(this, arguments);
    }
    return mounted;
  }(),
  watch: {
    'form.prescricaoId': {
      handler: function handler(newVal) {
        if (newVal) {
          this.selectedPrescription = this.prescricoesDisponiveis.find(function (p) {
            return p.id === newVal;
          });
        } else {
          this.selectedPrescription = null;
        }
      },
      immediate: true
    }
  },
  methods: {
    loadDropdowns: function () {
      var _loadDropdowns = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _this$farm, _yield$Promise$all, _yield$Promise$all2, prescriptionsResponse, sectorsResponse, equipmentsResponse, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              if ((_this$farm = this.farm) !== null && _this$farm !== void 0 && _this$farm.id) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              _context2.n = 2;
              return Promise.all([_application.applicationService.fetchPrescriptionsDropdown(this.farm.id), _application.applicationService.fetchSectorsDropdown(this.farm.id), _application.applicationService.fetchEquipmentsDropdown(this.farm.id)]);
            case 2:
              _yield$Promise$all = _context2.v;
              _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 3);
              prescriptionsResponse = _yield$Promise$all2[0];
              sectorsResponse = _yield$Promise$all2[1];
              equipmentsResponse = _yield$Promise$all2[2];
              this.prescricoesDisponiveis = prescriptionsResponse.data || [];
              this.setoresDisponiveis = sectorsResponse.data || [];
              this.equipamentosDisponiveis = equipmentsResponse.data || [];
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t = _context2.v;
              this.prescricoesDisponiveis = [];
              this.setoresDisponiveis = [];
              this.equipamentosDisponiveis = [];
            case 4:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 3]]);
      }));
      function loadDropdowns() {
        return _loadDropdowns.apply(this, arguments);
      }
      return loadDropdowns;
    }(),
    save: function () {
      var _save = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var setoresValidos, sectorIds, formData, success;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              if (!this.isEdit) {
                _context3.n = 2;
                break;
              }
              if (!(!this.form.prescricaoId && !this.form.dataAplicacao && !this.form.setores.length && !this.form.equipamentoId && !this.form.descricao)) {
                _context3.n = 1;
                break;
              }
              this.$buefy.toast.open({
                message: 'Preencha pelo menos um campo para atualizar',
                type: 'is-warning'
              });
              return _context3.a(2);
            case 1:
              _context3.n = 4;
              break;
            case 2:
              if (!(!this.form.prescricaoId || !this.form.dataAplicacao)) {
                _context3.n = 3;
                break;
              }
              this.$buefy.toast.open({
                message: 'Preencha todos os campos obrigatórios',
                type: 'is-warning'
              });
              return _context3.a(2);
            case 3:
              setoresValidos = this.form.setores.filter(function (s) {
                return s.setorId;
              });
              if (!(setoresValidos.length === 0)) {
                _context3.n = 4;
                break;
              }
              this.$buefy.toast.open({
                message: 'Adicione pelo menos um setor',
                type: 'is-warning'
              });
              return _context3.a(2);
            case 4:
              sectorIds = this.form.setores.filter(function (s) {
                return s.setorId;
              }).map(function (s) {
                return s.setorId;
              });
              formData = {
                prescricaoId: this.form.prescricaoId,
                descricao: this.form.descricao,
                dataAplicacao: (0, _moment.default)(this.form.dataAplicacao).format('YYYY-MM-DD'),
                sectorIds: sectorIds,
                equipamentoId: this.form.equipamentoId
              };
              success = false;
              if (!this.isEdit) {
                _context3.n = 6;
                break;
              }
              _context3.n = 5;
              return this.updateApplication(formData, this.application);
            case 5:
              success = _context3.v;
              _context3.n = 8;
              break;
            case 6:
              _context3.n = 7;
              return this.createApplication(formData);
            case 7:
              success = _context3.v;
            case 8:
              if (success) {
                this.onSuccess();
                this.cancelModal();
              }
            case 9:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function save() {
        return _save.apply(this, arguments);
      }
      return save;
    }(),
    addSetor: function addSetor() {
      this.form.setores.push({
        setorId: ''
      });
    },
    removeSetor: function removeSetor(index) {
      if (this.form.setores.length > 1) {
        this.form.setores.splice(index, 1);
      }
    },
    formatDatePicker: function formatDatePicker(date) {
      return (0, _moment.default)(date).format('DD/MM/YYYY');
    },
    cancelModal: function cancelModal() {
      this.$parent.close();
    }
  }
};